/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * How much of the enrollment the member does themselves; UNKNOWN when the enrollment is not managed by Zorro or the requirement data is missing
 */
export enum EnrollmentEffortTier {
  EASY_ENROLL = 'EASY_ENROLL',
  EXTRA_STEPS = 'EXTRA_STEPS',
  SELF_ENROLL = 'SELF_ENROLL',
  UNKNOWN = 'UNKNOWN',
}
